import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { DirtyComponent } from 'projects/shared/src/helpers/CanDeactivate/dirty-component';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { Lookup } from 'projects/shared/src/models/lookup';
import { LookupsService } from 'projects/shared/src/services/lookups.service';
import { SurveysOpinionTaskService } from 'projects/admin/src/app/shared/services/surveys-opinion-task.service';
import { SurveyTaskDetails } from '../../../../models/surveys-tasks/SurveyTaskDetails';
import { TargetAudienceGenderEnum } from 'projects/admin/src/app/features/surveys-requests/models/enums/TargetAudienceGenderEnum';

export interface DialogData {
  details: SurveyTaskDetails;
}
@Component({
  selector: 'app-ambassador-surveys-tasks-add-response',
  standalone: false,
  templateUrl: './ambassador-surveys-tasks-add-response.component.html'
})
export class AmbassadorSurveysTasksAddResponseComponent extends DirtyComponent implements OnInit {
  isSubmitted = false;
  loading = false;
  override formGroup: FormGroup = new FormGroup({});
  priorities: Lookup[] = [];
  priorityLoading = false;
  tracks: Lookup[] = [];
  tracksLoading = false;
  groups: Lookup[] = [];
  groupsLoading = false;
  ambassadors: Lookup[] = [];
  ambassadorsLoading = false;
  today = new Date();
  targetAudienceGenderEnum = TargetAudienceGenderEnum

  geographicScopes: any = [];
  geographicScopesLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    override dialogRef: MatDialogRef<AmbassadorSurveysTasksAddResponseComponent>,
    private formBuilder: FormBuilder,
    private service: SurveysOpinionTaskService,
    private el: ElementRef,
    translate: TranslateService,
    private swalService: SwalService,
    private lookupsService: LookupsService
  ) {
    super(translate)
  }

  ngOnInit(): void {
    this.getSurveyRequestGeographicScopeLookups()
    this.buildForm();
  }


  getSurveyRequestGeographicScopeLookups() {
    this.geographicScopesLoading = true;
    this.service.getSurveyRequestGeographicScopeLookups(this.data.details.taskId).subscribe((res: any) => {
      this.geographicScopes = res;
      this.geographicScopesLoading = false;
    }, (err: any) => {
      this.geographicScopesLoading = false;
    })
  }

  buildForm() {

    this.formGroup = this.formBuilder.group(
      {
        surveyRequestSuveryGeographicScopeId: [null, [Validators.required]],
        targetAudienceGender: [TargetAudienceGenderEnum.Male, [Validators.required]],
        respondentsName: [null, [Validators.required]],
        respondentsAge: [null, [Validators.required]],
      }
    );
  }

  saveRecord() {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.dialogRef.close(this.formGroup.value)
    } else {
      this.formGroup.markAllAsTouched();
      this.scrollToFirstInvalidControl();
    }
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      'form .ng-invalid'
    );
    firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }


  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
}

